// removed by extract-text-webpack-plugin
module.exports = {"highlight":"_2CTH4tH"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/SearchResultPage/components/FormattedMessage/FormattedMessage.less
 ** module id = 818
 ** module chunks = 0
 **/